export default "__VITE_ASSET__DR5CA5oD__"